import React from 'react';
import { BackIcon } from '../../assets/images/Icons/BackIcon';
import { COLORS } from '../../config/designSystem/Colors';
import { HeaderSide } from './HeaderSide';


interface HeaderRightProps {
    topPosition: number,
    leftPosition: number,
    onPress: () => void,
}

export const SIZE_TOP_BAR = 40;
export const HeaderLeft = ({ topPosition, leftPosition, onPress }: HeaderRightProps) => {
  const SIZE_ICON= 2/3*SIZE_TOP_BAR;


  return(
    <HeaderSide sidePosition={leftPosition} topPosition={topPosition} position={'left'} onPress={onPress}>
      <BackIcon tintColor={COLORS.brand[500]} size={SIZE_ICON} />
    </HeaderSide>

  );
};


